<template>
  <permission-guard situation="glossary_management">
    <DataLoader v-if="fetchLoading" :loading="fetchLoading" />
    <template v-else>
      <router-link class="d-block mb-2" to="/admin/glossary"
        >← 用語集設定に戻る</router-link
      >
      <h2 class="headline mb-3">用語編集</h2>
      <glossary-phrase-form :glossaryPhrase="glossaryPhrase" @update-glossary-phrase="updateGlossaryPhrase" @save-glossary-phrase="saveGlossaryPhrase" />
    </template>
  </permission-guard>
</template>

<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'
import { deserialize } from 'deserialize-json-api'
import GlossaryPhraseForm from './GlossaryPhraseForm'
import DataLoader from '@/components/commons/DataLoader'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    PermissionGuard,
    GlossaryPhraseForm,
    DataLoader
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: '用語編集',
      glossaryPhrase: {},
      fetchLoading: true
    }
  },
  async mounted () {
    this.fetchLoading = true
    await this.fetchGlossaryPhrase()
    this.fetchLoading = false
  },
  methods: {
    fetchGlossaryPhrase () {
      return axios
        .get(`/api/glossary_phrases/${this.$route.params.id}/edit`)
        .then(({ data }) => {
          this.glossaryPhrase = deserialize(data).data
          if (!this.glossaryPhrase.glossaryPhraseLinks) {
            this.glossaryPhrase.glossaryPhraseLinks = []
          }
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
    },
    formatQuery (glossaryPhrase) {
      let queryObj = glossaryPhrase
      if (glossaryPhrase.glossaryPhraseLinks) {
        const glossaryPhraseLinksAttributes = glossaryPhrase.glossaryPhraseLinks.map(
          (item, index) => {
            let obj = {
              linkType: item.linkType,
              priority: index,
              postId: item.postId,
              title: item.title,
              url: item.url,
              _destroy: item.destroy
            }
            if (item.id) {
              Object.assign(obj, { id: item.id })
            }
            return obj
          }
        )
        queryObj.glossaryPhraseLinksAttributes = glossaryPhraseLinksAttributes
      }
      return { glossaryPhrase: queryObj }
    },
    saveGlossaryPhrase () {
      const query = this.formatQuery(this.glossaryPhrase)
      axios.patch(`/api/glossary_phrases/${this.$route.params.id}`, query).then(
        () => {
          const payload = {
            status: 200,
            message: '変更を保存しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.fetchGlossaryPhrase()
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    updateGlossaryPhrase (glossaryPhrase) {
      this.glossaryPhrase = Object.assign({}, glossaryPhrase)
    }
  }
}
</script>
